"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("../Styles/DashboardContentArea.css");
var DashboardContentArea = /** @class */ (function (_super) {
    __extends(DashboardContentArea, _super);
    function DashboardContentArea(props) {
        return _super.call(this, props) || this;
    }
    DashboardContentArea.prototype.render = function () {
        return (React.createElement("div", { className: "dashboard-content-area" },
            React.createElement("h5", null, this.props.title),
            this.props.children));
    };
    return DashboardContentArea;
}(React.Component));
exports.DashboardContentArea = DashboardContentArea;
//# sourceMappingURL=DashboardContentArea.js.map